import EAButton from "../../../shared/Buttons/EAButton";
import HtmlTooltip from "@mui/material/Tooltip";
import { Ticket } from "../../../../models/Ticket";
import { useSelector } from "react-redux";
import { State } from "../../../../store";

// Komponent renderujący przyciski akcji
const ReservationActions: React.FC<{
  cancelReservation: boolean;
  setCancelReservation: (value: boolean) => void;
  onResign: () => void;
  exerciseStartTime: number;
  now: number;
  t: (key: string) => string;
  isDesktop: boolean;
  ticket: Ticket;
}> = ({ cancelReservation, setCancelReservation, onResign, exerciseStartTime, now, t, isDesktop, ticket }) => {
  const allowToChangeDate = useSelector((state: State) => state.config.configuration.allowReservedExerciseChange);

  if (!allowToChangeDate && !ticket.isExerciseSelfService) {
    return null;
  }

  if (cancelReservation) {
    if (isDesktop && exerciseStartTime <= now) {
      return (
        <HtmlTooltip placement="top" arrow={true} title={<article dangerouslySetInnerHTML={{ __html: "" }}></article>}>
          <EAButton
            title={t("zrezygnuj")}
            onClick={() => setCancelReservation(false)}
            color="error"
            variant="filled"
            disabled
          />
        </HtmlTooltip>
      );
    }

    return (
      <EAButton title={t("zrezygnuj")} onClick={() => setCancelReservation(false)} color="error" variant="filled" />
    );
  }

  return (
    <div className={`resing-wrapper ${!isDesktop ? "resing-wrapper__mobile" : ""}`}>
      <h5>Czy na pewno chcesz zrezygnować ?</h5>
      <div>
        <EAButton title={t("tak_rezygnuje")} onClick={onResign} color="error" variant="filled" />
        <EAButton title={t("nie")} onClick={() => setCancelReservation(true)} color="error" variant="outlined" />
      </div>
    </div>
  );
};

export default ReservationActions;
